import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import Videocam from 'material-ui/svg-icons/av/videocam'
import Message from 'material-ui/svg-icons/communication/message'

export default class DirectMessages extends Component {
  constructor() {
    super();
    this.state={
      open: false
    }
  }

  render() {
    const { showModal, onClose, user } = this.props;
    return (
        <Dialog
          open={showModal}
          onRequestClose={onClose}
          title="Ready to chat?"
          style={{ marginTop: -100}}
        >
          <RaisedButton
            label="Yes!"
            labelPosition="before"
            primary={true}
            icon={<Videocam />}
            style={{marginTop: 5}}
            fullWidth={true}
            onClick={() => this.setState({open: true})}
          />
        <Dialog contentStyle={{ width: '100%', height: '100%'}} bodyStyle={{ padding: '0 !important' }} open={this.state.open} onRequestClose={() => this.setState({open: false})}>
            <iframe src={`https://tokbox.com/embed/embed/ot-embed.js?embedId=d02558c5-cf31-4177-910e-75e2cea0ac06&room=${user.uid}&iframe=true`} width={'100%'} height={500} ></iframe>
          </Dialog>
        </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/directmessagemodal.jsx